var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"label":_vm.label,"items":_vm.typeList,"disabled":_vm.disabled,"allow-no-select":"","gray-placeholder":""},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }